import { create } from 'zustand'

export const OpenNotification = (state: NotificationStateInterface | any, payload: NotificationInterface | Array<NotificationInterface>) => {
    return {
        ...state,
        Notifications: [
            ...state.Notifications,
            Array.isArray(payload) ? [...payload] : payload
        ]
    }
}

export const CloseNotification = (state: NotificationStateInterface, id: number) => {
    return {
        ...state,
        Notifications: state.Notifications.filter(
            (notification: any) => notification.Id !== id
        )
    }
}

const NotificationState = create<NotificationStateInterface>((set) => {
    const NotificationInitialState: NotificationStateInterface = {
        Notifications: [],
        Open: (notification: NotificationInterface | Array<NotificationInterface>) => set((state: NotificationStateInterface) => OpenNotification(state, notification)),
        Close: (notification_id: number) => set((state: NotificationStateInterface) => CloseNotification(state, notification_id))
    }

    return NotificationInitialState
})

export default NotificationState
